export default __webpack_public_path__ + "static/media/HeroSVG4.b328d348.png";